import './i18n';          // ← add this line
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.05,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
});

// Keep the 37.9 KB replay bundle out of the critical path.
// Added on the first user interaction instead of on page load.
const _addReplay = () => {
  ['mousedown', 'keydown', 'touchstart', 'scroll'].forEach((ev) =>
    window.removeEventListener(ev, _addReplay)
  );
  Sentry.addIntegration(
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })
  );
};
['mousedown', 'keydown', 'touchstart', 'scroll'].forEach((ev) =>
  window.addEventListener(ev, _addReplay, { once: true, passive: true })
);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);